import {NodeModel} from "../model/NodeModel";
import {isNullOrUndefined} from "util";

export class TreeBuilderUtils {

    public static generate(list): NodeModel[] {
        let node;
        let tree: NodeModel[] = [];
        for (let item of list) {
            if (isNullOrUndefined(item.parentId)) {
                node = this.mapToNode(item);
                for (let child of list) {
                    node = this.addChild(node, child);
                }
                tree.push(node);
            }
        }
        return tree;
    }

    private static addChild(node: NodeModel, item): NodeModel {
        if (node.id == item.parentId) {
            node.children.push(this.mapToNode(item));
            return node;
        }
        for (let child of node.children) {
            if (child.id == item.parentId) {
                child.children.push(this.mapToNode(item));
                return node;
            } else {
                this.addChild(child, item);
            }
        }
        return node;
    }

    public static findAllLeavesOfNode(node: NodeModel, path?: string): { node: NodeModel, path: string }[] {
        let result = [];
        if (node.selectable) {
            result.push({node: node, path: path});
        }
        for (let child of node.children) {
            if (child.children.length == 0) {
                result = result.concat(this.findAllLeavesOfNode(child, path));
            } else {
                result = result.concat(this.findAllLeavesOfNode(child, path + '/' + this.getNameWithCode(child)));
            }
        }

        return result;
    }

    private static mapToNode(item): NodeModel {
        return {
            id: item.id,
            name: item.name,
            selectable: item.selectable,
            code: item.code,
            children: []
        }
    }

    private static getNameWithCode(item: NodeModel): string {
        return item.code + ' ' + item.name;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/tree/utils/tree-builder-utils.ts